import $rdf from '@zazuko/env/web.js';
const ns = $rdf.namespace('https://hypermedia.app/shape-to-query#');
export default ns;
